module.exports = __webpack_public_path__ + "static/media/muscu_sante.757a903a.jpg";